<template>
  <span>comapliance</span>
</template>
<script>
export default {};
</script>
